import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { bool, object, string } from 'yup';

import { formMessages } from '@/messages/forms';

export type WatchSchema = InferType<ReturnType<typeof watchSchema>>;

export const watchSchema = (formatMessage: IntlShape['formatMessage']) => {
  const requiredMsg = formatMessage(formMessages.requiredField);
  const MODEL_MIN_CHARS = 6;

  const schema = object({
    model: string()
      .required(requiredMsg)
      .default('')
      .min(
        MODEL_MIN_CHARS,
        formatMessage(formMessages.minChars, { min: MODEL_MIN_CHARS }),
      ),
    sn: string().required(requiredMsg).default(''),
    captcha: bool()
      .default(false)
      .oneOf([true], formatMessage(formMessages.requiredField)),
  });

  return schema;
};
